import { render, staticRenderFns } from "./ActiveIncidents.vue?vue&type=template&id=2392fa82&scoped=true&"
import script from "./ActiveIncidents.vue?vue&type=script&lang=js&"
export * from "./ActiveIncidents.vue?vue&type=script&lang=js&"
import style0 from "./ActiveIncidents.vue?vue&type=style&index=0&id=2392fa82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392fa82",
  null
  
)

export default component.exports